// Standalone site constants (no imports) to avoid circular dependencies between
// head.ts and schema.ts. BASE_URL is re-exported from head.ts for back-compat.
export const BASE_URL = "https://www.misupport.dk";
